// Module
var code = `<table class="table box-border positions-table jobs-listing-table"> <thead> <tr> <th ng-repeat="column in sortColumnsCtrl.columns" class="{{column.className}}" ng-click="sortColumnsCtrl.onColumnClick(column)"> {{ column.titleKey | translate }} </th> </tr> </thead> </table> `;
// Exports
export default code;